const colors = {
  dark: "#0C1B31",
  light: "#cdd7d6",
  mid: "#b3a394",
  accent: "#f87060",
  text: "#ffffff",
  error: "#ff3333",
};
export default colors;
